import { render, staticRenderFns } from "./card.vue?vue&type=template&id=652d3838&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=652d3838&prod&lang=scss&scoped=true&external"
import style1 from "./card.vue?vue&type=style&index=1&id=652d3838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d3838",
  null
  
)

export default component.exports